import { FloatingContainerProps } from 'layout/floating-container/floating-container.props';

export const FloatingContainerPresets: FloatingContainerProps = {
  children: null,
  left: '0',
  top: '0',
  visible: true,
};
